module["exports"] = [
  "######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/postcode.js
// module id = 1265
// module chunks = 0